module.exports = __webpack_public_path__ + "img/pro_s2_icon1.ec55ec6a.png";